module.exports = __webpack_public_path__ + "0711b5811da187b33b8f70c5fbe8e8df.pdf";